import { render, staticRenderFns } from "./StaticTab.vue?vue&type=template&id=bf365986&"
import script from "./StaticTab.vue?vue&type=script&lang=js&"
export * from "./StaticTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports